import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";

export const STAGES = ["受付", "現地調査", "見積", "受注", "施工", "完了", "納品", "請求", "入金"];
export const fieldClass = "min-w-0 w-full border border-line bg-ink px-3 py-2.5 text-sm text-white outline-none transition-colors focus:border-accent";
export const buttonClass = "inline-flex items-center justify-center gap-2 border border-line px-4 py-2.5 text-sm text-gray-200 transition-colors hover:border-accent hover:text-accent disabled:opacity-40 disabled:cursor-not-allowed";
export const primaryClass = "inline-flex items-center justify-center gap-2 bg-accent px-4 py-3 text-sm font-bold text-ink transition-colors hover:bg-accent-hover disabled:opacity-40 disabled:cursor-not-allowed";
export const yen = (value) => `¥${Number(value || 0).toLocaleString()}`;
export const japanDate = () => new Intl.DateTimeFormat("sv-SE", { timeZone: "Asia/Tokyo" }).format(new Date());

export const WorkflowField = ({ label, children }) => <label className="block min-w-0 space-y-2 text-xs text-gray-400"><span>{label}</span>{children}</label>;
export const WorkflowError = ({ error, id }) => error ? <p role="alert" data-testid={id} className="my-3 border-l-2 border-red-400 pl-3 text-sm text-red-300">{error}</p> : null;

export const useWorkflowAction = (pid, onChanged) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const run = async (method, action, payload) => {
    setBusy(true); setError("");
    try {
      const { data } = await api[method](`/admin/workflow/${pid}/${action}`, payload);
      if (data.warnings?.length) toast.warning(data.warnings.join("\n"), { duration: 10000 });
      else toast.success("記録しました");
      await onChanged();
      return true;
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "保存できませんでした。もう一度お試しください。");
      return false;
    } finally { setBusy(false); }
  };
  return { busy, error, run };
};